import { ICompany } from 'app/shared/model/company.model';
import { ITruckGroup } from 'app/shared/model/truck-group.model';
import { RiskClassification } from 'app/config/constants';
import { VirtualFenceSyncStatus } from 'app/shared/model/virtual-fence-circle.model';

export type { VirtualFenceSyncStatus };

export interface IVirtualFencePolygonPoint {
  id?: number;
  position?: number;
  latitude?: number | null;
  longitude?: number | null;
}

export interface IVirtualFencePolygon {
  id?: number;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  activated?: boolean | null;
  syncStatus?: VirtualFenceSyncStatus | null;
  riskClassification?: RiskClassification | null;
  notificationEnabled?: boolean | null;
  company?: ICompany | null;
  truckGroups?: ITruckGroup[] | null;
  points?: IVirtualFencePolygonPoint[] | null;
}

export const defaultValue: Readonly<IVirtualFencePolygon> = {
  activated: false,
};
